import { ConnectedSolveResult } from 'components/common-form/sidePanel/status/stream/SolveResult';
import { connectStream, StreamingProps } from 'components/common-form/sidePanel/status/stream/Stream.connect';
import { ConnectedUnderlying } from 'components/common-form/sidePanel/status/stream/Underlying';
import { useClassNameFromTradeWay } from 'components/common-form/sidePanel/status/useClassNameFromTradeway';
import { WaitingPrice } from 'components/shared/Price/WaitingPrice';
import {
  CancelButton,
  CircularCountdown,
  ConnectedTradeWayLiteral,
  PriceNext,
  QuoteStatus,
} from 'components/shared/PriceNext';
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar';
import { useProgressTimer } from 'hooks/useProgressTimer';
import { useCallback, useContext } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

import { SolveModeLabel } from '../../SolveMode';

function StreamingStatus({
  workspaceType,
  quoteRequestStartingTimeInMillis,
  estimatedQuotingDurationInMillis = 120000,
  solvingMode,
  children,
  tabId,
  quoteType,
  onQuoteCancelled,
}: StreamingProps) {
  const { progressInPercent, remainingTimeInSeconds } = useProgressTimer(
    quoteRequestStartingTimeInMillis,
    estimatedQuotingDurationInMillis,
  );
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const onCancel = useCallback(() => {
    logAnalytics.trackEvent(logAnalyticsCategory, 'Cancel quote (From status)');
    onQuoteCancelled();
  }, [onQuoteCancelled, logAnalyticsCategory]);

  const className = useClassNameFromTradeWay(tabId, workspaceType);

  if (workspaceType === 'static' || workspaceType === 'dynamic') {
    return (
      <PriceNext
        className={className}
        tradeWay={<ConnectedTradeWayLiteral tabId={tabId} workspaceType={workspaceType} />}
        solveMode={
          <SolveModeLabel workspaceType={workspaceType} solvingMode={solvingMode} isMultipleSolvingMode={false} />
        }
        fxSpot={<ConnectedUnderlying formId={tabId} />}
        solveResult={<ConnectedSolveResult formId={tabId} />}
        countDownBar={<ProgressBar percent={100 - progressInPercent} />}
        quoteStatus={
          <QuoteStatus
            icon={CircularCountdown}
            description={
              quoteType === 'Indicative' ? 'sidePanel.quoteStatus.indicativeFor' : 'sidePanel.quoteStatus.tradableFor'
            }
            remainingTimeInSeconds={remainingTimeInSeconds}
            action={<CancelButton className="text-turquoise-50" onCancel={onCancel} />}
          />
        }
      />
    );
  }

  return (
    <WaitingPrice
      color={'success'}
      onCancel={onCancel}
      progressInPercent={progressInPercent}
      topRightActions={children}
    />
  );
}

export const StreamingStatusComponent = connectStream(StreamingStatus);
